import React from "react";
import "./TMHFormStyles.css";

function TMHMemberPin({pinNumber}) {
    const numbers = pinNumber.toString().split("");

    const listItems = numbers.map((number, index) =>
        <span key={index} className="tmhform-pin">
            {number}
        </span>
    );
    return <div>{listItems}</div>;
}

export default TMHMemberPin;
